import 'tooltipster';

const kickstartTooltipster = () => {

  $('.tooltip').tooltipster({
    contentCloning: true,
    animation: 'fade',
    delay: 200,
    minWidth: 288,
    maxWidth: 355,
    fixedWidth: 280,
    theme: ['tooltipster-shadow', 'custom'],
    side: 'top',
    trigger: 'custom',
    triggerOpen: {
      click: true,  // For mouse
      tap: true    // For touch device
    },
    triggerClose: {
      click: true,  // For mouse
      tap: true    // For touch device
    },
    viewportAware: false,
    debug: false,
    interactive: true,
    functionReady(origin, tooltip) {
      $(tooltip.tooltip).on( 'click', '.close-tooltip', () => {
        $(tooltip.origin).tooltipster('hide');
      });
    },
    zIndex: 5
  });
};

export default kickstartTooltipster;
